module.exports = __webpack_public_path__ + "img/yellow-lines.a68e51f3.svg";